import { clsx } from 'clsx';
import React from 'react';

/**
 * Info banner rendered in place of the status/shift/expense actions when an
 * assignment or timecard is org-sourced (1099): its lifecycle and pay are
 * owned by the organization's imported data files, so the drawer is view-only
 * apart from documents and comments.
 */
export const OrgManagedBanner: React.FC<{ message: string; className?: string }> = ({
  message,
  className,
}) => (
  <div
    className={clsx(
      'tw:p-2 tw:bg-blue-50 tw:border tw:border-blue-200 tw:rounded-lg tw:text-sm tw:text-blue-700',
      className
    )}
  >
    <div className="tw:flex tw:items-start tw:gap-2">
      <i className="fas fa-info-circle tw:text-blue-700 tw:mt-0.5" />
      <p className="tw:!mb-0">{message}</p>
    </div>
  </div>
);
